import React from "react";
import * as BS from "react-bootstrap";
import { Icon, WrapperLess } from "../generic";

interface OwnProps {
    className?: string;
    entity: string;
    includeCopy?: boolean;
    includeDelete?: boolean;
    includeEdit?: boolean;
    onCopy?: () => void;
    onDelete?: () => void;
    onEdit?: () => void;
}

export const CrudTools: React.SFC<OwnProps> = (props) => {
    const includeCopy = props.includeCopy;
    const includeDelete = props.includeDelete === undefined ? true : props.includeDelete;
    const includeEdit = props.includeEdit === undefined ? true : props.includeEdit;

    const onCopy = props.onCopy ? props.onCopy : () => {};
    const onDelete = props.onDelete ? props.onDelete : () => {};
    const onEdit = props.onEdit ? props.onEdit : () => {};

    const copy = includeCopy
        ? <BS.Button bsStyle="link" title={"Copy " + props.entity} onClick={() => onCopy()}><Icon icon="copy fa-lg" /></BS.Button>
        : null;
    const deleteBtn = includeDelete
        ? <BS.Button bsStyle="link" title={"Delete " + props.entity} onClick={() => onDelete()}><Icon icon="times fa-lg" /></BS.Button>
        : null;
    const edit = includeEdit
        ? <BS.Button bsStyle="link" title={"Edit " + props.entity} onClick={() => onEdit()}><Icon icon="pencil fa-lg" /></BS.Button>
        : null;

    return <WrapperLess>
        {props.children}
        <BS.ButtonGroup className={props.className}>
            {edit}
            {copy}
            {deleteBtn}
        </BS.ButtonGroup>
    </WrapperLess>;
};



// WEBPACK FOOTER //
// ./src/components/tools/CrudTools.tsx